import React from "react";
import CONSTS from "../../consts";
export default class MultiOptionImage extends React.Component {
    constructor(props) {
        super(props);
        this.imageExtensions = [".jpg", ".png", ".gif"];
        this.imageError = (src, imageNum) => {
            let newImageSet = [...this.state.unavailableImages];
            newImageSet.push(imageNum);
            this.setState({
                unavailableImages: newImageSet
            });
            src.currentTarget.hidden = true;
        };
        this.state = {
            unavailableImages: []
        };
    }
    componentWillReceiveProps(nextProps, props) {
        if (!props) {
            this.setState({
                unavailableImages: []
            });
        }
        if (((props === null || props === void 0 ? void 0 : props.SKU) !== (nextProps === null || nextProps === void 0 ? void 0 : nextProps.SKU)) || ((props === null || props === void 0 ? void 0 : props.Prefix) !== (nextProps === null || nextProps === void 0 ? void 0 : nextProps.Prefix))) {
            this.setState({
                unavailableImages: []
            });
        }
    }
    renderImage(source, index, className) {
        return React.createElement("img", { key: index, className: className, src: source, onClick: () => this.props.setImage(source), onError: (src) => this.imageError(src, index), alt: "liquor-img" });
    }
    render() {
        var _a, _b, _c;
        const images = [];
        for (let i = 0; i < this.imageExtensions.length; i++) {
            let ext = this.imageExtensions[i];
            if (this.state.unavailableImages.indexOf(i) >= 0) {
                continue;
            }
            if (!((_a = this.props.Prefix) === null || _a === void 0 ? void 0 : _a.trim())) {
                const productSource = `${CONSTS.STORAGEURL}/${CONSTS.PRODUCTCONTAINER}/${(_c = (_b = this.props.SKU) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : "NotAvail"}${ext}`;
                images.push(this.renderImage(productSource, i, this.props.IsActive ? 'active' : ""));
            }
            else {
                let imageSource = `${CONSTS.STORAGEURL}/${CONSTS.AGENTCONTAINER}/${this.props.SKU ? this.props.SKU.trim() : "NotAvail"}${this.props.Prefix.trim()}${ext}`;
                images.push(this.renderImage(imageSource, i, this.props.IsActive ? 'active' : ""));
            }
        }
        return React.createElement(React.Fragment, null, images);
    }
}
//# sourceMappingURL=MultiOptionImage.js.map